module.exports = __webpack_public_path__ + "da7e777f95f8738b444157db613c6ecf.png";